import { useEffect, useState } from 'react';

/*
 * One shared 1-second ticker per mount site (LiveConsole mounts it once and
 * passes elapsed seconds down), mirroring the prototype's single setInterval.
 * The interval is cleared on unmount.
 */
export const useCountdown = (enabled: boolean): number => {
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    if (!enabled) return undefined;
    const id = window.setInterval(() => setElapsed((e) => e + 1), 1000);
    return () => window.clearInterval(id);
  }, [enabled]);

  return elapsed;
};

/*
 * Countdown copy CLAMPS at zero (never negative, fixtures never act):
 *   remaining > 0  -> "Offers in N min"  (N >= 1)
 *   remaining <= 0 -> "Due now"
 */
export const formatCountdown = (
  secondsRemaining: number,
  elapsed: number,
): string => {
  const remaining = secondsRemaining - elapsed;
  if (remaining <= 0) return 'Due now';
  return `Offers in ${Math.max(1, Math.floor(remaining / 60))} min`;
};
